/** @jsxImportSource @emotion/react */
import { useLingui } from '@lingui/react/macro';
import type { OnboardingStep } from 'modules/main/domain/interfaces/onboarding-step';
import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { useLayoutEffect, useState } from 'react';
import type { DivProps } from 'typings';
import { ClickableArea } from 'ud-ui/components';
import RhombusIcon from 'ud-ui/components/icon/rhombus-icon';
import UDLink from 'ud-ui/components/link';
import Text from 'ud-ui/components/text';
import * as S from './styles';

export interface IStepProps extends DivProps, OnboardingStep {}

function Step(props: IStepProps) {
  const { emoji, header, action, to, checkProperty, ...rest } = props;
  const { t } = useLingui();
  const [isComplete, setComplete] = useState(false);

  useLayoutEffect(() => {
    if (checkProperty) {
      setComplete(StepperMainTool.getByPath(checkProperty));
    }
  }, [checkProperty]);

  return (
    <S.MainBlock {...rest}>
      <S.EmojiBlock>{emoji}</S.EmojiBlock>
      <RhombusIcon isComplete={isComplete} />
      <Text variant="subtitle-1" center>
        {t(header)}
      </Text>
      <UDLink to={to} className="typo subtitle-1-bold active">
        <ClickableArea horizontalExtend={20} verticalExtend={20}>
          {t(action)}
        </ClickableArea>
      </UDLink>
    </S.MainBlock>
  );
}

export default Step;
